<div class="preloader">
    <h2 class="loader">Loading...</h2>
</div>